import { createContext } from 'react';

export type FileTreeState = {
  isSidebarCollapsed: boolean;
  setIsSidebarCollapsed: (isCollapsed: boolean) => void;
  sidebarWidth: number;
  setSidebarWidth: (width: number) => void;
};

const STARTING_WIDTH = 300;

const defaultState: FileTreeState = {
  isSidebarCollapsed: false,
  setIsSidebarCollapsed: () => {},
  sidebarWidth: STARTING_WIDTH,
  setSidebarWidth: () => {},
};

export const FileTreeContext = createContext(defaultState);
